// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"bffedb18","995":"46400ad4"}[chunkId] + ".chunk.css";
};